(function ($) {

	"use strict";

	const ArrangementSearch = {

		init: function init() {

			this.query = this.query || "";
			this.location = undefined;

			this.searchBox = $("[data-enhancer='arrangementSearchBox']");
			this.sortOrder = $("[data-arrangementSearch-sortOrder]");
			this.clearButton = $("[data-arrangementSearch-clearQuery");
			this.hitsLabel = $("[data-arrangmentSearch-hitsLabel]");
			this.filterCounters = $("[data-arrangementSearch-filterCounter]");

			this.loadMoreButton = $("[data-arrangementSearch-loadMore");

			this.searchBox.on("search", function (event, data) { ArrangementSearch.onSearch(event, data) });
			this.searchBox.on("queryChange", function (event, data) { ArrangementSearch.onQueryChange(event, data) });
			this.searchBox.on("locationChange", function (event, data) { ArrangementSearch.onLocationChanged(event, data) });

			this.sortOrder.on("change", function (event) { 
				event.preventDefault();
				ArrangementSearch.onSearch(event);
			})

			this.clearButton.on("click", function () { ArrangementSearch.onClearQuery(); });

			this.loadMoreButton.on("click", function () { ArrangementSearch.onLoadMore($(this).attr("data-arrangementSearch-loadMore")); });

			this.getFilters(true).each(function () {
				$(this).on("arrangementFilterChanged", function (event, data) { ArrangementSearch.onFilterChanged(event, data); });
			});

		},

		getFilters: function getFilters(all = false) {
			if (all) {
				return $("[data-enhancer='arrangementFilter'], [data-arrangementfilter-staticfilter]");
			}

			if ($('.sidebar').is(':visible')) {
				return $(".sidebar [data-enhancer='arrangementFilter'], [data-arrangementfilter-staticfilter]");
			} else {
				return $("#filtermenu [data-enhancer='arrangementFilter'], [data-arrangementfilter-staticfilter]");
			}

			
		},

		getResultContainer: function getResultContainer() {
			return $("[data-arrangementSearch-resultContainer");
		},

		getSearchQueryString: function getSearchQueryString(filters) {
			return filters.map(function () {
				if ($(this).is("input")) {
					return this.name + "=" + this.value;
				}
				return $(this).attr("data-arrangementFilter-parameter-name") + "=" + $(this).attr("data-arrangmentFilter-filterValue");
			}).get();
		},

		getSearchUrl: function getSearchUrl() {
			if (this.searchBox && this.searchBox.length > 0) {
				return this.searchBox.attr("data-arrangementSearch-url");
			}
			return "";
		},

		getSortOrder: function getSortOrder() {
			if (this.sortOrder && this.sortOrder.length > 0) {
				return this.sortOrder.val();
			}
			return "";
		},

		getViewContainer: function getViewContainer() {
			return $("[data-arrangmentSearch-viewContainer");
		},

		onClearQuery: function onClearQuery() {
			this.query = "";
			this.search(this.getSearchUrl(), this.query, this.location, this.getFilters());
		},

		onFilterChanged: function onFilterChanged(event, data) {
			this.search(this.getSearchUrl(), this.query, this.location, this.getFilters(), 1, this.getViewContainer());
		},

		onLoadMore: function onLoadMore(pageNumber) {
			var p = parseInt(pageNumber);
			if (!p) {
				p = 2;
			}
			this.search(this.getSearchUrl(), this.query, this.location, this.getFilters(), p, this.getResultContainer(), true);
		},

		onLocationChanged: function onLocationChanged(event, data) {
			$("[data-arrangementfilter-staticfilter][name='l']").val("");
			this.location = data;
		},

		onQueryChange: function onQueryChange(event, data) {
			this.query = data;
		},

		onSearch: function onSearch(event, data) {
			this.search(this.getSearchUrl(), this.query, this.location, this.getFilters());
		},

		search: function search(url, query, location, filters, pageNumber = 1, target = undefined, loadMore = false) {

			var searchUrl = url + "?query=" + query;
			var sortOrder = this.getSortOrder();

			if (sortOrder && sortOrder != "") {
				searchUrl += "&s=" + sortOrder;
			}

			if (location != undefined && location != "") {
				filters = filters.filter(function () {
					return $(this).attr("data-arrangementfilter-parameter-name") != "ll";
				});
				searchUrl += "&ll=" + location;
			}

			filters = filters.filter(function () {
				return $(this).attr("data-arrangmentFilter-filterValue") != undefined && $(this).attr("data-arrangmentFilter-filterValue") != "";
			});

			this.updateFilterCounter(filters);

			if (filters != undefined && filters.length > 0) {
				searchUrl += "&" + ArrangementSearch.getSearchQueryString(filters).join("&");
			}

			searchUrl += "&p=" + pageNumber;

			if (loadMore) {
				searchUrl += "&loadmore=true";
			}

			if (target) {
				$.ajax({
					url: searchUrl,
					dataType: "html",
					timeout: 15000,
					cache: false,
					success: data => {
						if (loadMore) {
							target.replaceWith(data);
						} else {
							var filterContainers = $("[data-arrangementFilter='container']");
							var filterUpdate = $(data).find("[data-arrangementFilter='container']");
							filterContainers.each(function () {
								$(this).html(filterUpdate[0].innerHTML)
							});
							target.html(data);
							filterContainers = $("[data-arrangementFilter='container']");
							filterContainers.each(function () {
								$.initEnhancers(this);
							});
						}
						$.initEnhancers(target);
						this.init();
						this.hitsLabel.html(this.getResultContainer().attr("data-arrangementSearch-resultContainer"));
					},
					complete: () => {
						this.updateHistory(searchUrl);
					},
					error: function (xhr, status, error) {
						console.log("Ett fel uppstod när resultat listan skulle uppdateras.", status, error);
					}
				});
			} else {
				window.location = searchUrl;
			}

		},
		updateHistory: function (requestUrl) {
			const formatedUrl = requestUrl.substring(requestUrl.indexOf("?")).replace("&loadmore=true", "");

			// Update url, dont update the history
			history.replaceState(null, null, formatedUrl);
		},

		updateFilterCounter: function (activeFilters) {
			var value = 0;
			activeFilters.each(function () {
				var filterValue = $(this).attr('data-arrangmentfilter-filtervalue').split(',');
				value += filterValue.length;
			});
			this.filterCounters.text(value);
			this.filterCounters.toggleClass("d-none", !(value > 0));
		},

	};

	$(document).ready(ArrangementSearch.init());


})(jQuery);